import { render, staticRenderFns } from "./PageSecurityScripts.vue?vue&type=template&id=267b1bc7"
import script from "./PageSecurityScripts.vue?vue&type=script&lang=js"
export * from "./PageSecurityScripts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports